import { Typography } from "@/design-system/Atoms";
import { useDashboardTabs } from "@/hooks/useDashboardTabs";
import DashboardContent from "./DashboardContent";
import { DashboardSidebar } from "@/design-system/Molecules";

export const DashboardContainer = () => {
  const { activeTabId, handleTabChange } = useDashboardTabs();

  return (
    <section className="min-h-screen">
      <div className="container mx-auto px-4">
        <Typography
          variant="sectionHeading"
          as="h2"
          className="my-10"
        >
          My Account
        </Typography>

        <div className="flex flex-col lg:flex-row lg:gap-7 mb-[4.68rem] lg:mb-[10rem]">
          <DashboardSidebar
            activeTabId={activeTabId}
            onTabChange={handleTabChange}
          />

          <DashboardContent activeTabId={activeTabId} />
        </div>
      </div>
    </section>
  );
};

export default DashboardContainer;